/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  ItemBase,
  ItemBaseOptional,
  ItemBaseMetaI,
  ItemBaseTrackedI,
} from "./item-base";
import { ItemBaseTracked, ItemBaseMeta } from "./item-base";
// May contain unused imports in some cases
// @ts-ignore
import type {
  SubscriptionBase,
  SubscriptionBaseOptional,
  SubscriptionBaseMetaI,
  SubscriptionBaseTrackedI,
} from "./subscription-base";
import {
  SubscriptionBaseTracked,
  SubscriptionBaseMeta,
} from "./subscription-base";
// May contain unused imports in some cases
// @ts-ignore
import type {
  SubscriptionItemFull,
  SubscriptionItemFullOptional,
  SubscriptionItemFullMetaI,
  SubscriptionItemFullTrackedI,
} from "./subscription-item-full";
import {
  SubscriptionItemFullTracked,
  SubscriptionItemFullMeta,
} from "./subscription-item-full";

/**
 *
 * @export
 * @interface CatalogSubscriptionItemDTO
 */
export interface CatalogSubscriptionItemDTOOptional extends SubscriptionItemFullOptional {
  /**
   *
   * @type {boolean}
   * @memberof CatalogSubscriptionItemDTO
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CatalogSubscriptionItemDTO
   */
  isNew?: boolean;
  /**
   *
   * @type {number}
   * @memberof CatalogSubscriptionItemDTO
   */
  assignId?: number;
  /**
   *
   * @type {number}
   * @memberof CatalogSubscriptionItemDTO
   */
  cyclePriceOverrideCents?: number;
  /**
   *
   * @type {SubscriptionBase}
   * @memberof CatalogSubscriptionItemDTO
   */
  subscriptionId?: SubscriptionBaseOptional;
  /**
   *
   * @type {ItemBase}
   * @memberof CatalogSubscriptionItemDTO
   */
  itemId?: ItemBaseOptional;
}

export interface CatalogSubscriptionItemDTO
  extends CatalogSubscriptionItemDTOOptional, SubscriptionItemFull {
  /**
   *
   * @type {boolean}
   * @memberof CatalogSubscriptionItemDTO
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CatalogSubscriptionItemDTO
   */
  isNew?: boolean;
  /**
   *
   * @type {number}
   * @memberof CatalogSubscriptionItemDTO
   */
  assignId: number;
  /**
   *
   * @type {number}
   * @memberof CatalogSubscriptionItemDTO
   */
  cyclePriceOverrideCents?: number;
  /**
   *
   * @type {SubscriptionBase}
   * @memberof CatalogSubscriptionItemDTO
   */
  subscriptionId: SubscriptionBase;
  /**
   *
   * @type {ItemBase}
   * @memberof CatalogSubscriptionItemDTO
   */
  itemId: ItemBase;
}

export interface CatalogSubscriptionItemDTOTrackedI extends SubscriptionItemFullOptional {
  /**
   *
   * @type {boolean}
   * @memberof CatalogSubscriptionItemDTO
   */
  isDeleted?: boolean;
  isDeletedIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CatalogSubscriptionItemDTO
   */
  isNew?: boolean;
  isNewIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof CatalogSubscriptionItemDTO
   */
  assignId?: number;
  assignIdIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof CatalogSubscriptionItemDTO
   */
  cyclePriceOverrideCents?: number;
  cyclePriceOverrideCentsIsSet: boolean;
  /**
   *
   * @type {SubscriptionBase}
   * @memberof CatalogSubscriptionItemDTO
   */
  subscriptionId?: SubscriptionBaseTrackedI;
  subscriptionIdIsSet: boolean;
  /**
   *
   * @type {ItemBase}
   * @memberof CatalogSubscriptionItemDTO
   */
  itemId?: ItemBaseTrackedI;
  itemIdIsSet: boolean;
}

transformDatesMap.set(
  "CatalogSubscriptionItemDTO",
  function (model: CatalogSubscriptionItemDTO) {
    const transformDatessubscriptionId =
      transformDatesMap.get("SubscriptionBase");
    if (transformDatessubscriptionId && model.subscriptionId) {
      transformDatessubscriptionId(model.subscriptionId);
    }
    const transformDatesitemId = transformDatesMap.get("ItemBase");
    if (transformDatesitemId && model.itemId) {
      transformDatesitemId(model.itemId);
    }
  },
);

export type CatalogSubscriptionItemDTOMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  isDeleted: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  isNew: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  assignId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  cyclePriceOverrideCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  subscriptionId: PropertyMeta<SubscriptionBaseMetaI>;
  //isDate: false
  //isDatetime: false
  itemId: PropertyMeta<ItemBaseMetaI>;
}>;

export var CatalogSubscriptionItemDTOMeta: CatalogSubscriptionItemDTOMetaI =
  {} as CatalogSubscriptionItemDTOMetaI;
CatalogSubscriptionItemDTOMeta = typeMeta("CatalogSubscriptionItemDTO", {
  isDeleted: propertyMeta(
    "isDeleted",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  isNew: propertyMeta("isNew", false, false, false, MetaTypesBase.boolean),
  assignId: propertyMeta("assignId", false, true, true, MetaTypesBase.number),
  cyclePriceOverrideCents: propertyMeta(
    "cyclePriceOverrideCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  subscriptionId: propertyMeta(
    "subscriptionId",
    false,
    true,
    false,
    SubscriptionBaseMeta,
  ),
  itemId: propertyMeta("itemId", false, true, false, ItemBaseMeta),
});

const metaI = CatalogSubscriptionItemDTOMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([SubscriptionItemFullMeta]);
  metaI.isDeleted.inheritedFrom = SubscriptionItemFullMeta.isDeleted;
  metaI.isNew.inheritedFrom = SubscriptionItemFullMeta.isNew;
  metaI.assignId.inheritedFrom = SubscriptionItemFullMeta.assignId;
  metaI.cyclePriceOverrideCents.inheritedFrom =
    SubscriptionItemFullMeta.cyclePriceOverrideCents;
  metaI.subscriptionId.inheritedFrom = SubscriptionItemFullMeta.subscriptionId;
  metaI.itemId.inheritedFrom = SubscriptionItemFullMeta.itemId;
});

export class CatalogSubscriptionItemDTOTracked
  extends SubscriptionItemFullTracked
  implements CatalogSubscriptionItemDTOTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  isDeleted__I?: boolean = undefined;
  isDeletedIsSet: boolean = false;
  set isDeleted(v: undefined | boolean) {
    if (v !== undefined) {
      this.isDeleted__I = v;
      this.isDeletedIsSet = true;
    } else {
      this.isDeleted__I = v || undefined;
      this.isDeletedIsSet = false;
    }
    this.changeTracker = true;
  }
  get isDeleted() {
    return this.isDeleted__I;
  }
  isNew__I?: boolean = undefined;
  isNewIsSet: boolean = false;
  set isNew(v: undefined | boolean) {
    if (v !== undefined) {
      this.isNew__I = v;
      this.isNewIsSet = true;
    } else {
      this.isNew__I = v || undefined;
      this.isNewIsSet = false;
    }
    this.changeTracker = true;
  }
  get isNew() {
    return this.isNew__I;
  }
  assignId__I?: number = undefined;

  get assignIdIsSet() {
    return this.assignId !== undefined;
  }
  set assignIdIsSet(v: boolean) {}
  set assignId(v: undefined | number) {
    if (v !== undefined) {
      this.assignId__I = v;
      this.assignIdIsSet = true;
    } else {
      this.assignId__I = v || undefined;
      this.assignIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get assignId() {
    return this.assignId__I;
  }
  cyclePriceOverrideCents__I?: number = undefined;
  cyclePriceOverrideCentsIsSet: boolean = false;
  set cyclePriceOverrideCents(v: undefined | number) {
    if (v !== undefined) {
      this.cyclePriceOverrideCents__I = v;
      this.cyclePriceOverrideCentsIsSet = true;
    } else {
      this.cyclePriceOverrideCents__I = v || undefined;
      this.cyclePriceOverrideCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get cyclePriceOverrideCents() {
    return this.cyclePriceOverrideCents__I;
  }
  subscriptionId__I?: SubscriptionBaseTracked = undefined;
  subscriptionIdIsSet: boolean = false;
  set subscriptionId(v: undefined | SubscriptionBaseTracked) {
    if (v !== undefined) {
      this.subscriptionId__I = v;
      this.subscriptionIdIsSet = true;
    } else {
      this.subscriptionId__I = v || undefined;
      this.subscriptionIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get subscriptionId() {
    return this.subscriptionId__I;
  }
  itemId__I?: ItemBaseTracked = undefined;
  itemIdIsSet: boolean = false;
  set itemId(v: undefined | ItemBaseTracked) {
    if (v !== undefined) {
      this.itemId__I = v;
      this.itemIdIsSet = true;
    } else {
      this.itemId__I = v || undefined;
      this.itemIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get itemId() {
    return this.itemId__I;
  }
  constructor(
    config?: CatalogSubscriptionItemDTOOptional,
    options?: AssignOptions,
  ) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.assignIdIsSet == true && other?.assignIdIsSet == true)
      return this.assignId == other.assignId;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.assignId) {
      this.assignIdIsSet = true;
    }

    this.subscriptionId?.setIds();

    this.itemId?.setIds();
  }
  assignFrom(
    config: CatalogSubscriptionItemDTOOptional,
    options?: AssignOptions,
  ): CatalogSubscriptionItemDTOTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.isDeleted && this.isDeletedApplyFilter(optionsRequired.filter)) {
      this.isDeleted = config.isDeleted;
      if (optionsRequired.unassign) this.isDeletedIsSet = false;
      else this.isDeletedIsSet = true;
    }
    if (config.isNew && this.isNewApplyFilter(optionsRequired.filter)) {
      this.isNew = config.isNew;
      if (optionsRequired.unassign) this.isNewIsSet = false;
      else this.isNewIsSet = true;
    }
    if (config.assignId && this.assignIdApplyFilter(optionsRequired.filter)) {
      this.assignId = config.assignId;
      if (optionsRequired.unassign) this.assignIdIsSet = false;
      else this.assignIdIsSet = true;
    }
    if (
      config.cyclePriceOverrideCents &&
      this.cyclePriceOverrideCentsApplyFilter(optionsRequired.filter)
    ) {
      this.cyclePriceOverrideCents = config.cyclePriceOverrideCents;
      if (optionsRequired.unassign) this.cyclePriceOverrideCentsIsSet = false;
      else this.cyclePriceOverrideCentsIsSet = true;
    }
    if (
      config.subscriptionId &&
      this.subscriptionIdApplyFilter(optionsRequired.filter)
    ) {
      this.subscriptionId = new SubscriptionBaseTracked(
        config.subscriptionId,
        options,
      );
      if (optionsRequired.unassign) this.subscriptionIdIsSet = false;
      else this.subscriptionIdIsSet = true;
    }
    if (config.itemId && this.itemIdApplyFilter(optionsRequired.filter)) {
      this.itemId = new ItemBaseTracked(config.itemId, options);
      if (optionsRequired.unassign) this.itemIdIsSet = false;
      else this.itemIdIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): CatalogSubscriptionItemDTOTrackedI {
    const cloned = {} as CatalogSubscriptionItemDTOTrackedI;
    if (
      this.isDeletedIsSetDeep() &&
      this.isDeletedApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isDeletedIsSet = true;
      cloned.isDeleted = this.isDeleted;
    } else {
      //cloned.isDeletedIsSet = false
    }
    if (
      this.isNewIsSetDeep() &&
      this.isNewApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isNewIsSet = true;
      cloned.isNew = this.isNew;
    } else {
      //cloned.isNewIsSet = false
    }
    if (
      this.assignIdIsSetDeep() &&
      this.assignIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.assignIdIsSet = true;
      cloned.assignId = this.assignId;
    } else {
      //cloned.assignIdIsSet = false
    }
    if (
      this.cyclePriceOverrideCentsIsSetDeep() &&
      this.cyclePriceOverrideCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.cyclePriceOverrideCentsIsSet = true;
      cloned.cyclePriceOverrideCents = this.cyclePriceOverrideCents;
    } else {
      //cloned.cyclePriceOverrideCentsIsSet = false
    }
    if (
      this.subscriptionIdIsSetDeep() &&
      this.subscriptionIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.subscriptionIdIsSet = true;
      cloned.subscriptionId = this.subscriptionId?.removeUnset(filter);
    } else {
      //cloned.subscriptionIdIsSet = false
    }
    if (
      this.itemIdIsSetDeep() &&
      this.itemIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.itemIdIsSet = true;
      cloned.itemId = this.itemId?.removeUnset(filter);
    } else {
      //cloned.itemIdIsSet = false
    }
    if (!isDeleted(this) && !this.assignIdIsSet) updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): CatalogSubscriptionItemDTOTrackedI {
    if (!this.isDeletedApplyFilter(filter)) this.isDeletedIsSet = false;

    if (!this.isNewApplyFilter(filter)) this.isNewIsSet = false;

    if (!this.assignIdApplyFilter(filter)) this.assignIdIsSet = false;

    if (!this.cyclePriceOverrideCentsApplyFilter(filter))
      this.cyclePriceOverrideCentsIsSet = false;

    if (!this.subscriptionIdApplyFilter(filter))
      this.subscriptionIdIsSet = false;
    this.subscriptionId?.unassignAll(filter);

    if (!this.itemIdApplyFilter(filter)) this.itemIdIsSet = false;
    this.itemId?.unassignAll(filter);

    return this;
  }
  isDeletedApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogSubscriptionItemDTOMeta.isDeleted,
      CatalogSubscriptionItemDTOMeta,
      this.isDeleted,
      this,
    );
  }
  isDeletedIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isDeletedIsSet && this.isDeletedApplyFilter(filter)) return true;

    return false;
  }
  isNewApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogSubscriptionItemDTOMeta.isNew,
      CatalogSubscriptionItemDTOMeta,
      this.isNew,
      this,
    );
  }
  isNewIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isNewIsSet && this.isNewApplyFilter(filter)) return true;

    return false;
  }
  assignIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogSubscriptionItemDTOMeta.assignId,
      CatalogSubscriptionItemDTOMeta,
      this.assignId,
      this,
    );
  }
  assignIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.assignIdIsSet && this.assignIdApplyFilter(filter)) return true;

    return false;
  }
  cyclePriceOverrideCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogSubscriptionItemDTOMeta.cyclePriceOverrideCents,
      CatalogSubscriptionItemDTOMeta,
      this.cyclePriceOverrideCents,
      this,
    );
  }
  cyclePriceOverrideCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.cyclePriceOverrideCentsIsSet &&
      this.cyclePriceOverrideCentsApplyFilter(filter)
    )
      return true;

    return false;
  }
  subscriptionIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogSubscriptionItemDTOMeta.subscriptionId,
      CatalogSubscriptionItemDTOMeta,
      this.subscriptionId,
      this,
    );
  }
  subscriptionIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.subscriptionIdIsSet && this.subscriptionIdApplyFilter(filter))
      return true;
    return this.subscriptionId?.anySet(filter) == true;

    return false;
  }
  itemIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogSubscriptionItemDTOMeta.itemId,
      CatalogSubscriptionItemDTOMeta,
      this.itemId,
      this,
    );
  }
  itemIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.itemIdIsSet && this.itemIdApplyFilter(filter)) return true;
    return this.itemId?.anySet(filter) == true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.isDeletedIsSetDeep(filter)) return true;
    if (this.isNewIsSetDeep(filter)) return true;
    if (this.assignIdIsSetDeep(filter)) return true;
    if (this.cyclePriceOverrideCentsIsSetDeep(filter)) return true;
    if (this.subscriptionIdIsSetDeep(filter)) return true;
    if (this.itemIdIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
